import { Link } from "react-router-dom";

import {
    PageWrapper,
    Section,
    Subsection,
    Line,
    EmailLink,
    Paragraph
} from "./components";

const LandingPage = () => {
    return <PageWrapper>
        <Paragraph>Bridging the gap between tech and bio in early stage drug discovery.</Paragraph>

        <Section title='Resources' scrollId='resources' >
            <Subsection
                to='https://scalingbiotech.substack.com/'
                title='Scaling Biotech'
            >
                This weekly newsletter explores the factors that have limited tech adoption in early stage drug discovery, and the ways we can address these bottlenecks for the next generation of digital models.
            </Subsection>
            <Subsection
                title='Reference Frameworks'
                to='/frameworks/'
            >
                A collection of resources designed to help readers break down common types of problems into manageable pieces.
            </Subsection>
            <Subsection
                title='Digital Tool Directory'
                to='/directory/'
            >
                A manually curated and categorized list of digital tools, models and infrastructure that are defining the future of drug discovery.
            </Subsection>
            {/* <Subsection
                title='Data Operations Plans For Early Discovery Labs'
                to='/data_operations_plans/'
            >
                One of the main tools we use with clients is a Data Operations Plan. This white paper explains what a Plan looks like, how we build one, and how we ensure your team will continue to follow and improve the plan as your organization grows.
            </Subsection> */}
        </Section>

        <Section title='Services' scrollId='services'>
            <Paragraph>
                I help drug discovery teams reliably adopt digital tools, models and infrastructure by designing and coordinating complex rollouts across scientific and technical teams.
            </Paragraph><Paragraph>
                Often, AI/ML can't slot directly into the existing scientific process. As a consultant, I define how the process needs to evolve, then work with internal teams, contractors and vendors to iterate on the science in parallel with the technology.  My clients include pharma companies, techbio startups and cloud labs.
            </Paragraph>
        </Section>

        <Section title='Contact' scrollId='contact'>
            <Paragraph>
                You can reach my by email or find me on LinkedIn:
            </Paragraph>
            <Paragraph>
                <Line>
                    <Link
                        to='https://www.linkedin.com/in/jesse-johnson-biotech/'
                        target='_blank'
                        rel='noopener noreferrer'
                    >Jesse Johnson</Link>, Founder & CEO: <EmailLink />
                </Line>
                <Line>
                    <Link
                        to='https://www.linkedin.com/company/merelogic/'
                        target='_blank'
                        rel='noopener noreferrer'
                    >Merelogic on Linkedin</Link>
                </Line>
            </Paragraph>
        </Section>
    </PageWrapper>
}

export default LandingPage;